/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Crop_RightInputs */

const en_ocr_crop_right = /** @type {(inputs: Ocr_Crop_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right (%)`)
};

const fr_ocr_crop_right = /** @type {(inputs: Ocr_Crop_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Droite (%)`)
};

const de_ocr_crop_right = /** @type {(inputs: Ocr_Crop_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechts (%)`)
};

const it_ocr_crop_right = /** @type {(inputs: Ocr_Crop_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giusto (%)`)
};

const ru_ocr_crop_right = /** @type {(inputs: Ocr_Crop_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Верно (%)`)
};

const es_ocr_crop_right = /** @type {(inputs: Ocr_Crop_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bien (%)`)
};

const zh_cn2_ocr_crop_right = /** @type {(inputs: Ocr_Crop_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正确的 （％）`)
};

const ja_ocr_crop_right = /** @type {(inputs: Ocr_Crop_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`右 （％）`)
};

const hi_ocr_crop_right = /** @type {(inputs: Ocr_Crop_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सही (%)`)
};

const pt_pt2_ocr_crop_right = /** @type {(inputs: Ocr_Crop_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certo (%)`)
};

/**
* | output |
* | --- |
* | "Right (%)" |
*
* @param {Ocr_Crop_RightInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_crop_right = /** @type {((inputs?: Ocr_Crop_RightInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Crop_RightInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_crop_right(inputs)
	if (locale === "de") return de_ocr_crop_right(inputs)
	if (locale === "it") return it_ocr_crop_right(inputs)
	if (locale === "ru") return ru_ocr_crop_right(inputs)
	if (locale === "es") return es_ocr_crop_right(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_crop_right(inputs)
	if (locale === "ja") return ja_ocr_crop_right(inputs)
	if (locale === "hi") return hi_ocr_crop_right(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_crop_right(inputs)
	return en_ocr_crop_right(inputs)
});